import { useCallback, useState } from "react";
import { Skeleton, TextField, Typography } from "@mui/material";
import { KababMenu } from "shared/components/Menu/KababMenu";
import { SquaresOutlineIcon } from "shared/icons/SquaresOutlineIcon";
import { isPositionValid } from "@coolset/cs-ui";

export const TableCellSpan = (props: TableCellSpanProps) => {
  const {
    onChange,
    blockPosition,
    isLoading,
  } = props;

  return (
    <div className="layout-block-form">
      {isLoading ? (
        <div className="_d-grid-md-gap">
          <Skeleton />
          <Skeleton width="80%" />
          <Skeleton width="90%" />
        </div>
      ) : (
        <>
          <div className="_d-flex-ali-center-jc-sb-sm-gap">
            <Typography variant="h4" color="text.secondary">
              Position span
            </Typography>
            <KababMenu
              icon={<SquaresOutlineIcon sx={{ width: 24, height: 24 }} />}
              menuProps={{ classes: { list: "_d-flex-ali-center-md-gap row-col-dialog" } }}
              items={[
                <CellSpanInput
                  key="rows"
                  value={blockPosition}
                  onChange={onChange}
                  title="Position span (required)"
                />,
              ]}
            />
          </div>
        </>
      )}
    </div>
  );
};

interface TableCellSpanProps {
  onChange: (position: string) => void;
  blockPosition?: string;
  isLoading: boolean;
}

const CellSpanInput = (props: { value?: string; onChange: (position: string) => void; title: string }) => {
  const { value, onChange, title } = props;
  const [newValue, setNewValue] = useState<string | undefined>(value);

  const handleBlur = useCallback((inputValue: string) => {
    const shouldSave = value && value !== inputValue && isPositionValid(inputValue);
    if (shouldSave) {
      onChange(inputValue);
    }
  }, [onChange, value]);

  return (
    <div>
      <Typography color="text.secondary" mb={1}>
        {title}
      </Typography>
      <TextField
        defaultValue={value}
        onChange={(event) => setNewValue(event.target.value)}
        onBlur={(event) => handleBlur(event.target.value)}
        error={!isPositionValid(newValue) && !!newValue}
        helperText={!isPositionValid(newValue) && !!newValue && "Invalid position"}
      />
    </div>
  );
};
